module.exports = __webpack_public_path__ + "static/media/close.afd4c681.svg";